<template>
  <main class="app-shell">
    <Suspense>
      <template #default>
        <PrepareUniver
          :user-id="currentUser.id"
          :user-name="currentUser.name"
          :tenant-id="currentUser.tenantId"
          :workbook-key="currentUser.workbookKey"
        />
      </template>
      <template #fallback>
        <div class="editor-loading">正在加载表格编辑器...</div>
      </template>
    </Suspense>
  </main>
</template>

<script setup lang="ts">
import { defineAsyncComponent } from 'vue'

const PrepareUniver = defineAsyncComponent(() => import('@/components/PrepareUniver.vue'))

const currentUser = {
  id: 'local-user',
  name: '本地用户',
  tenantId: 'local',
  workbookKey: 'standalone-univer',
}
</script>

<style scoped lang="less">
.app-shell {
  display: flex;
  height: 100vh;
  overflow: hidden;
}

.editor-loading {
  flex: 1;
  display: grid;
  place-items: center;
  color: #64748b;
  font-size: 14px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
}
</style>
